let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bqaEy")).then(() => parcelRequire('eONcC'));